import axios from "axios";

// Resolve the backend base URL.
// In production behind a custom domain, the frontend and backend live on the
// SAME origin (e.g. https://serafricachapter.org/api/...), so we always prefer
// the current window origin when it differs from the build-time REACT_APP_BACKEND_URL.
// This avoids cross-origin requests + invalid CORS combinations.
function resolveBackendBase() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (typeof window === "undefined") return envUrl;
  const here = window.location.origin;
  // If env URL is missing OR points to a different host than where the user is,
  // use the current origin (same-origin call → no CORS).
  if (!envUrl) return here;
  try {
    const envHost = new URL(envUrl).host;
    if (envHost !== window.location.host) {
      return here;
    }
  } catch {
    return here;
  }
  return envUrl;
}

const BACKEND_URL = resolveBackendBase();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export default api;
